import { createFileRoute } from '@tanstack/react-router';

import { OccupancyTab } from '../../components/analytics/occupancy-tab';
import { useYear } from '../../hooks/use-year';

export const Route = createFileRoute('/$orgPid/analytics/occupancy')({
  component: AnalyticsOccupancyTab,
});

function AnalyticsOccupancyTab() {
  const { boatPid, boats, owner, sort } = Route.useSearch();
  const year = useYear();
  return (
    <OccupancyTab year={String(year)} boatPid={boatPid} boats={boats} owner={owner} sort={sort} />
  );
}
